// Vanilla JS - All jQuery code has been migrated
// Wait for DOM to be ready before executing (replaces jQuery $(function(){}) behavior)
(function() {
  // Declare init function first (before calling it)
  function init() {
  // ============================================
  // STEP 1: Product Addons Popup - MIGRATED TO VANILLA JS
  // ============================================
  // Remove href attribute after 1 second
  setTimeout(function(){
    document.querySelectorAll('.u_popup_toggle').forEach(function(toggle) {
      toggle.removeAttribute('href');
    });
  }, 1000);
  
  // Click handler with event delegation
  document.addEventListener('click', function(e) {
    const popupToggle = e.target.closest('.u_popup_toggle');
    if (popupToggle) {
      e.preventDefault();
      const productAddonsText = document.querySelector('.product-addons-text');
      if (productAddonsText) {
        productAddonsText.click();
      }
    }
  });
  // ============================================
  // STEP 2: Cart Overlay & Mobile Cart Position - MIGRATED TO VANILLA JS
  // ============================================
  // Close mobile menu when search or cart is clicked
  document.addEventListener('click', function(e) {
    const target = e.target.closest('.block-quick-search, .bls-minicart-action');
    if (target) {
      const hamberger = document.querySelector('.u_hamberger');
      const mobileMenu = document.querySelector('.u_mobile_menu');
      const mobileMenuOverlay = document.querySelector('.u_mb_menu_overlay');
      const html = document.documentElement;
      
      if (hamberger) hamberger.classList.remove('change');
      if (mobileMenu) mobileMenu.classList.remove('active');
      // Hide mobile menu overlay
      if (mobileMenuOverlay) {
        mobileMenuOverlay.style.display = 'none';
      }
      if (html) html.classList.remove('overflow');
    }
  });
  
  // Cart overlay close handler (custom overlay - .u_cart_overlay)
  // NOTE: Close button (.button-close) is handled by theme.js (product.js line 731-734)
  document.addEventListener('click', function(e) {
    const cartOverlay = e.target.closest('.u_cart_overlay');
    if (cartOverlay) {
      e.stopPropagation();
      const headerMinicart = document.querySelector('.header_minicart');
      const html = document.documentElement;
      const mobileMenuOverlay = document.querySelector('.u_mb_menu_overlay');
      const mobileMenu = document.querySelector('.u_mobile_menu');
      const hamberger = document.querySelector('.u_hamberger');
      
      // Close cart
      if (headerMinicart) headerMinicart.classList.remove('bls__opend-popup-header');
      if (html) html.classList.remove('hside_opened');
      
      // Check if mobile menu is currently active
      const isMobileMenuActive = mobileMenu && mobileMenu.classList.contains('active');
      
      // Only close mobile menu overlay if menu is actually open
      if (isMobileMenuActive) {
        if (mobileMenuOverlay) {
          mobileMenuOverlay.style.display = 'none';
        }
        if (mobileMenu) mobileMenu.classList.remove('active');
        if (hamberger) hamberger.classList.remove('change');
        if (html) html.classList.remove('overflow');
      }
    }
  });
  
  // ============================================
  // STEP 3: Mobile Menu Toggle - MIGRATED TO VANILLA JS
  // ============================================
  
  // Helper function for slide toggle animation (replaces jQuery slideToggle)
  function slideToggle(element, duration = 300) {
    if (!element) return;
    
    if (window.getComputedStyle(element).display === 'none') {
      // Slide down (open)
      element.style.display = 'block';
      const height = element.scrollHeight;
      element.style.height = '0px';
      element.style.overflow = 'hidden';
      element.style.transition = `height ${duration}ms ease`;
      
      setTimeout(() => {
        element.style.height = height + 'px';
      }, 10);
      
      setTimeout(() => {
        element.style.height = '';
        element.style.overflow = '';
        element.style.transition = '';
      }, duration);
    } else {
      // Slide up (close)
      const height = element.scrollHeight;
      element.style.height = height + 'px';
      element.style.overflow = 'hidden';
      element.style.transition = `height ${duration}ms ease`;
      
      setTimeout(() => {
        element.style.height = '0px';
      }, 10);
      
      setTimeout(() => {
        element.style.display = 'none';
        element.style.height = '';
        element.style.overflow = '';
        element.style.transition = '';
      }, duration);
    }
  }
  
  // Mobile menu hamburger and overlay toggle
  document.addEventListener('click', function(e) {
    const target = e.target.closest('.u_hamberger, .u_mb_menu_overlay');
    if (target) {
      const hamberger = document.querySelector('.u_hamberger');
      const mobileMenu = document.querySelector('.u_mobile_menu');
      const navUlMb = document.querySelector('.u_nav_ul_mb');
      const mobileMenuOverlay = document.querySelector('.u_mb_menu_overlay');
      const html = document.documentElement;
      
      if (hamberger) hamberger.classList.toggle('change');
      if (mobileMenu) mobileMenu.classList.toggle('active');
      
      // Toggle display using computed style check
      if (navUlMb) {
        const isHidden = window.getComputedStyle(navUlMb).display === 'none';
        navUlMb.style.display = isHidden ? 'block' : 'none';
      }
      if (mobileMenuOverlay) {
        const isHidden = window.getComputedStyle(mobileMenuOverlay).display === 'none';
        mobileMenuOverlay.style.display = isHidden ? 'block' : 'none';
      }
      
      if (html) html.classList.toggle('overflow');
    }
  });
  
  // Mobile navigation - first level dropdown toggle (with slide animation)
  document.addEventListener('click', function(e) {
    const menuLink = e.target.closest('.u_menu__link, .u_ficon_mb');
    if (menuLink) {
      const parent = menuLink.parentElement;
      const icon = parent.querySelector('i');
      const dropdown = parent.parentElement.querySelector('.u_sec_dropdown_mb');
      
      if (icon) {
        icon.classList.toggle('fa-angle-up');
        icon.classList.toggle('fa-angle-down');
      }
      
      if (dropdown) {
        slideToggle(dropdown);
      }
    }
  });
  
  // Mobile navigation - second level dropdown toggle (reverse, with slide animation)
  document.addEventListener('click', function(e) {
    const menuDLink = e.target.closest('.u_menu__dlink');
    if (menuDLink) {
      const secDropdown = menuDLink.closest('.u_sec_dropdown_mb');
      if (secDropdown) {
        const firstLevel = secDropdown.querySelector('.u_dropdown_list_mb_level:first-child .u_navbar_item_link_mb_level');
        if (firstLevel) firstLevel.classList.toggle('u_active_smenu');
      }
      
      menuDLink.classList.toggle('u_active_smenu');
      
      const parent = menuDLink.parentElement;
      const icon = parent.querySelector('i');
      const thirdDropdown = parent.parentElement.querySelector('.u_third_dropdown_mb');
      
      if (icon) {
        icon.classList.toggle('fa-angle-up');
        icon.classList.toggle('fa-angle-down');
      }
      
      if (thirdDropdown) {
        slideToggle(thirdDropdown);
      }
    }
  });
  
  // Mobile navigation - third level dropdown toggle (sicon, with slide animation)
  document.addEventListener('click', function(e) {
    const siconMb = e.target.closest('.u_sicon_mb');
    if (siconMb) {
      const secDropdown = siconMb.closest('.u_sec_dropdown_mb');
      if (secDropdown) {
        const firstLevel = secDropdown.querySelector('.u_dropdown_list_mb_level:first-child .u_navbar_item_link_mb_level');
        if (firstLevel) firstLevel.classList.toggle('u_active_smenu');
      }
      
      const dropdownListInner = siconMb.closest('.u_dropdown_list_mb_inner');
      if (dropdownListInner) {
        const levelLink = dropdownListInner.querySelector('.u_navbar_item_link_mb_level');
        if (levelLink) levelLink.classList.toggle('u_active_smenu');
      }
      
      const parent = siconMb.parentElement;
      const icon = parent.querySelector('i');
      const thirdDropdown = parent.parentElement.querySelector('.u_third_dropdown_mb');
      
      if (icon) {
        icon.classList.toggle('fa-angle-up');
        icon.classList.toggle('fa-angle-down');
      }
      
      if (thirdDropdown) {
        slideToggle(thirdDropdown);
      }
    }
  });
  
  // Collection Sidebar - Auto-open parent dropdowns for active items
  document.addEventListener('DOMContentLoaded', function() {
    // Find all active links in collection sidebar
    const activeLinks = document.querySelectorAll('.collection-sidebar .collection-category-link.active, .collection-sidebar .collection-category-link-level2.active, .collection-sidebar .collection-category-link-level3.active');
    
    activeLinks.forEach(function(activeLink) {
      // Open parent dropdowns
      let parent = activeLink.closest('.collection-category-item, .collection-category-level2');
      
      while (parent) {
        // Find the dropdown that contains this parent
        const dropdown = parent.querySelector('.u_sec_dropdown_mb, .u_third_dropdown_mb');
        if (dropdown) {
          dropdown.style.display = 'block';
          
          // Update icon to show it's open
          const icon = parent.querySelector('.collection-category-icon i');
          if (icon) {
            icon.classList.remove('fa-angle-down');
            icon.classList.add('fa-angle-up');
          }
        }
        
        // Move up to parent level
        parent = parent.parentElement?.closest('.collection-category-item, .collection-category-level2');
      }
      
      // Mark active submenu items
      if (activeLink.classList.contains('collection-category-link-level2') || activeLink.classList.contains('collection-category-link-level3')) {
        activeLink.classList.add('u_active_smenu');
      }
    });
    
    // Collection Sidebar - Back button functionality
    const backButton = document.querySelector('.collection-category-back-link[data-action="show-full-menu"]');
    if (backButton) {
      backButton.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Hide submenu view and show full menu view
        const submenuView = document.querySelector('.collection-menu-submenu-view');
        const fullMenuView = document.querySelector('.collection-menu-full-view');
        
        if (submenuView && fullMenuView) {
          submenuView.style.display = 'none';
          fullMenuView.classList.remove('collection-menu-hidden');
        }
      });
    }
  });
  
  // Product Size Selection - Vanilla JS
  document.addEventListener('click', function(e) {
    const sizeBtn = e.target.closest('.u_pro_satc_btn');
    if (sizeBtn) {
      console.log('click');
      sizeBtn.classList.add('u_btn_s_clr');
      
      const defaultText = document.querySelector('.u_atc_default_text');
      const sizeText = document.querySelector('.u_atc_size_text');
      
      if (defaultText) defaultText.style.display = 'none';
      if (sizeText) sizeText.textContent = 'SELECTEER EERST EEN MAAT';
      
      setTimeout(function() {
        sizeBtn.classList.remove('u_btn_s_clr');
        if (defaultText) defaultText.style.display = '';
        if (sizeText) sizeText.textContent = '';
      }, 3000);
    }
  });
  // Read More/Less - Vanilla JS
  document.addEventListener('click', function(e) {
    const readMoreBtn = e.target.closest('.u_read_more,.u_less_more');
    if (readMoreBtn) {
      console.log('click tab');
      const tabPanel = readMoreBtn.closest('.tab-panel');
      const readMoreWrapper = readMoreBtn.closest('.u_read_more_wrapper');
      
      if (readMoreWrapper) readMoreWrapper.classList.toggle('u_active_text');
      if (tabPanel) {
        tabPanel.classList.toggle('u_active_text');
        const tabWrapper = tabPanel.querySelector('.u_tab_wrapper');
        if (tabWrapper) tabWrapper.classList.toggle('u_inline_text');
      }
    }
  });

  // Show More Button Visibility Check
  // Only show the button if content is actually taller than max-height + margin
  function checkShowMoreButtonVisibility() {
    const tabWrappers = document.querySelectorAll('.u_tab_wrapper');
    
    tabWrappers.forEach(function(wrapper) {
      const maxHeightStyle = window.getComputedStyle(wrapper).maxHeight;
      
      // Check if max-height is set (not 'none')
      if (maxHeightStyle && maxHeightStyle !== 'none' && maxHeightStyle !== '0px') {
        // Get max-height value from data attribute or parse from style
        let maxHeight = parseInt(wrapper.dataset.maxHeight);
        if (!maxHeight || isNaN(maxHeight)) {
          maxHeight = parseInt(maxHeightStyle);
        }
        
        // Get margin from data attribute, default to 30px
        const margin = parseInt(wrapper.dataset.margin) || 30;
        
        // Get actual scroll height (full content height)
        const scrollHeight = wrapper.scrollHeight;
        
        // Calculate threshold
        const threshold = maxHeight + margin;
        
        // Find the corresponding read more wrapper (in same tab-panel)
        const tabPanel = wrapper.closest('.tab-panel');
        if (tabPanel) {
          const readMoreWrapper = tabPanel.querySelector('.u_read_more_wrapper');
        
          if (readMoreWrapper) {
          // Hide button if content is not significantly taller than max-height + margin
          if (scrollHeight <= threshold) {
              readMoreWrapper.style.display = 'none';
              tabPanel.classList.add('u_hide_read_more');
          } else {
              readMoreWrapper.style.display = '';
              tabPanel.classList.remove('u_hide_read_more');
            }
          }
        }
      }
    });
  }

  // Run on page load
  document.addEventListener('DOMContentLoaded', function() {
    // Wait a bit for content to render
    setTimeout(checkShowMoreButtonVisibility, 100);
    setTimeout(checkShowMoreButtonVisibility, 500);
  });

  // Run on window resize (with debounce)
  let resizeTimerShowMore;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimerShowMore);
    resizeTimerShowMore = setTimeout(function() {
      checkShowMoreButtonVisibility();
    }, 250);
  });

  // Also check when tabs are opened/closed
  document.addEventListener('click', function(e) {
    const tabTrigger = e.target.closest('.tab-item .item.title, .data.item');
    if (tabTrigger) {
    setTimeout(checkShowMoreButtonVisibility, 300);
    }
  });

  // Upsell add to cart functionality - Vanilla JS
  document.addEventListener('click', function(e) {
    const button = e.target.closest('.upsell_add_to_cart_btn');
    if (!button) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    const variantId = button.dataset.variantId;
    const productId = button.dataset.productId;
    
    if (!variantId) {
      console.error('Variant ID not found');
      return;
    }
    
    // Disable button and add loading state
    button.disabled = true;
    button.classList.add('btn-loading');
    
    // Get cart element
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    
    // Create form data
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
    }
    
    // Fetch config
    const config = typeof fetchConfig === 'function' ? fetchConfig('json') : {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;
    
    // Add to cart
    const cartAddUrl = (typeof routes !== 'undefined' && routes.cart_add_url) ? routes.cart_add_url : '/cart/add.js';
    
    fetch(`${cartAddUrl}.js`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        // Update cart count
        fetch('/cart.json')
          .then(res => res.json())
          .then(cart => {
            document.querySelectorAll(".cart-count").forEach(el => {
              if (el.classList.contains('cart-count-drawer')) {
                el.innerHTML = `(${cart.item_count})`;
              } else {
                el.innerHTML = cart.item_count;
              }
            });
            
            // Update free shipping progress bar if exists
            const cart_free_ship = document.querySelector("free-ship-progress-bar");
            if (cart_free_ship && typeof cart_free_ship.init === 'function') {
              cart_free_ship.init(cart.items_subtotal_price);
            }
          })
          .catch((error) => {
            console.error('Error updating cart count:', error);
          });
        
        // Update cart sections if cart element exists
        if (cart && typeof cart.getSectionsToRender === 'function') {
          const parsedState = JSON.parse(state);
          cart.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id);
            if (elementToReplace && parsedState.sections && parsedState.sections[section.id]) {
              const html = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html');
              const cartContent = html.querySelector('#form-mini-cart');
              if (cartContent) {
                elementToReplace.innerHTML = cartContent.innerHTML;
              }
              
              // Update countdown if exists
              const countdown = cart.querySelector('.cart-countdown-time');
              const html_countdown = html.querySelector('.cart-countdown-time');
              if (countdown && html_countdown) {
                countdown.innerHTML = html_countdown.innerHTML;
                if (typeof cart.countdownTimer === 'function') {
                  cart.countdownTimer();
                }
              }
            }
          }));
          
          // Trigger cart action if method exists
          if (typeof cart.cartAction === 'function') {
            cart.cartAction();
          }
        }
        
        // Open cart drawer/notification
        if (cart && typeof cart.open === 'function') {
          cart.open();
        }
      })
      .catch((e) => {
        console.error('Error adding to cart:', e);
        // You could show an error message here
      })
      .finally(() => {
        // Re-enable button and remove loading state
        button.disabled = false;
        button.classList.remove('btn-loading');
        
        // Reinitialize lazy load images if function exists
        if (typeof BlsLazyloadImg !== 'undefined' && typeof BlsLazyloadImg.init === 'function') {
          BlsLazyloadImg.init();
        }
      });
  });

  // Upsell Load More functionality - ULTRA SIMPLE VERSION WITH DEBUG
  (function() {
    'use strict';
    
    const DEBUG = false; // Set to true for console logging
    function log() {
      if (DEBUG && console && console.log) {
        console.log.apply(console, arguments);
      }
    }
    
    // Simple state per group
    const groupState = {};
    
    function getItemsPerLoad() {
      const items = window.innerWidth > 575 ? 2 : 1;
      log('getItemsPerLoad:', items, 'width:', window.innerWidth);
      return items;
    }

    function getInitialVisibleCount() {
      const items = window.innerWidth > 575 ? 2 : 1;
      log('getInitialVisibleCount:', items, 'width:', window.innerWidth);
      return items;
    }

      // Initialize a single group
      function initGroup(groupId) {
        log('=== INIT GROUP:', groupId, '===');
        
        // CRITICAL FIX: Skip if already initialized OR loading OR user has clicked
        if (groupState[groupId]) {
          if (groupState[groupId].loading) {
            log('Already loading, skip init');
            return;
          }
          if (groupState[groupId].initialized && groupState[groupId].userHasClicked) {
            log('User has clicked, skip re-init');
            return;
          }
          if (groupState[groupId].initialized) {
            log('Already initialized, skip init');
            return;
          }
        }
        
        // CRITICAL FIX: Get ALL wrappers with this group ID
        const wrappers = document.querySelectorAll(`[data-upsell-group-id="${groupId}"][data-enable-load-more="true"]`);
        if (wrappers.length === 0) {
          log('No wrappers found for groupId:', groupId);
          return;
        }
        
        log('Found', wrappers.length, 'wrappers for groupId:', groupId);
        
        const loadMoreBtn = document.querySelector(`.upsell-load-more-btn[data-group-id="${groupId}"]`);
        if (!loadMoreBtn) {
          log('No button found');
          return;
        }
        
        const totalProducts = parseInt(loadMoreBtn.getAttribute('data-total-products')) || 0;
        const initialVisible = getInitialVisibleCount();
        
        log('Total:', totalProducts, 'InitialVisible:', initialVisible);
        
        // Process EACH wrapper
        wrappers.forEach(function(wrapper) {
          const products = Array.from(wrapper.querySelectorAll('.upsell-product-item'));
          log('Processing wrapper with', products.length, 'products');
          
          if (products.length === 0) return;
          
          // Reset - remove all classes and inline styles
          products.forEach(function(product, i) {
            product.classList.remove('upsell-product-hidden');
            product.style.display = ''; // Clear any inline style
            log('Product', i, '- reset');
          });
          
          // Then hide based on viewport
          products.forEach(function(product, index) {
            if (index >= initialVisible) {
              product.classList.add('upsell-product-hidden');
              log('Product', index, '- hidden');
            } else {
              log('Product', index, '- visible');
            }
          });
        });
        
        // Initialize state
        groupState[groupId] = {
          initialized: true,
          loading: false,
          visibleCount: initialVisible,
          totalProducts: totalProducts,
          userHasClicked: false
        };
        
        log('State after init:', groupState[groupId]);
        
        // Update button
        updateButtonVisibility(groupId, loadMoreBtn, wrappers[0], totalProducts);
      }

    function updateButtonVisibility(groupId, btn, wrapper, totalProducts) {
      if (!btn || !wrapper) return;
      
      const loadMoreWrapper = btn.closest('.upsell-load-more-wrapper');
      if (!loadMoreWrapper) return;
      
      const visibleCount = wrapper.querySelectorAll('.upsell-product-item:not(.upsell-product-hidden)').length;
      
      log('updateButtonVisibility - visible:', visibleCount, 'total:', totalProducts);
      
      if (visibleCount >= totalProducts) {
        loadMoreWrapper.style.display = 'none';
        log('Hide button');
      } else {
        loadMoreWrapper.style.display = 'block';
        log('Show button');
      }
      
      if (groupState[groupId]) {
        groupState[groupId].visibleCount = visibleCount;
      }
    }

    function initAllGroups() {
      log('=== INIT ALL GROUPS ===');
      const wrappers = document.querySelectorAll('[data-enable-load-more="true"]');
      log('Found wrappers:', wrappers.length);
      
      wrappers.forEach(function(wrapper) {
        const groupId = wrapper.getAttribute('data-upsell-group-id');
        if (groupId) {
          initGroup(groupId);
        }
      });
    }

      // Click handler
      document.addEventListener('click', function(e) {
        const btn = e.target.closest('.upsell-load-more-btn');
        if (!btn) return;
        
        e.preventDefault();
        e.stopPropagation();
        
        const groupId = btn.getAttribute('data-group-id');
        if (!groupId) {
          log('No groupId on button');
          return;
        }
        
        log('=== BUTTON CLICKED:', groupId, '===');
        
        // Init if needed
        if (!groupState[groupId] || !groupState[groupId].initialized) {
          log('Not initialized, init now');
          initGroup(groupId);
        }
        
        // Check loading
        if (groupState[groupId] && groupState[groupId].loading) {
          log('Already loading');
          return false;
        }
        
        // Mark loading AND that user has clicked
        if (!groupState[groupId]) {
          groupState[groupId] = { initialized: true, loading: false, visibleCount: 0, totalProducts: 0, userHasClicked: false };
        }
        groupState[groupId].loading = true;
        groupState[groupId].userHasClicked = true;
        log('Set loading = true, userHasClicked = true');
        
        // CRITICAL FIX: Use querySelectorAll to update ALL matching wrappers
        const wrappers = document.querySelectorAll(`[data-upsell-group-id="${groupId}"][data-enable-load-more="true"]`);
        log('Found', wrappers.length, 'wrappers to update');
        
        if (wrappers.length === 0) {
          log('No wrappers found');
          groupState[groupId].loading = false;
          return false;
        }
        
        // Collect products to show from ALL wrappers
        const allProductsToShow = [];
        
        wrappers.forEach(function(wrapper) {
          const products = Array.from(wrapper.querySelectorAll('.upsell-product-item'));
          const itemsPerLoad = getItemsPerLoad();
          
          log('Wrapper products:', products.length, 'ItemsPerLoad:', itemsPerLoad);
          
          // Find hidden products in this wrapper
          const productsToShow = [];
          for (let i = 0; i < products.length && productsToShow.length < itemsPerLoad; i++) {
            const isHidden = products[i].classList.contains('upsell-product-hidden');
            if (products[i] && isHidden) {
              productsToShow.push(products[i]);
            }
          }
          
          log('ProductsToShow in this wrapper:', productsToShow.length);
          
          // Add to global list
          allProductsToShow.push(...productsToShow);
        });
        
        if (allProductsToShow.length === 0) {
          log('No products to show at all');
          groupState[groupId].loading = false;
          return false;
        }
        
        // Show loading on button
        btn.disabled = true;
        const textSpan = btn.querySelector('.upsell-load-more-text');
        const loaderSpan = btn.querySelector('.upsell-load-more-loader');
        if (textSpan) textSpan.style.display = 'none';
        if (loaderSpan) {
          loaderSpan.style.display = 'inline-block';
          loaderSpan.style.visibility = 'visible';
        }
        
        // Show products AFTER loader animation (700ms for better UX)
        setTimeout(function() {
          log('=== SHOW PRODUCTS AFTER LOADER ===');
          
          // NOW remove hidden class from products
          allProductsToShow.forEach(function(product) {
            product.classList.remove('upsell-product-hidden');
            log('Removed hidden class from product');
          });
          
          // Update button visibility for first wrapper
          const firstWrapper = wrappers[0];
          const newVisibleCount = firstWrapper.querySelectorAll('.upsell-product-item:not(.upsell-product-hidden)').length;
          const totalProducts = parseInt(btn.getAttribute('data-total-products')) || newVisibleCount;
          
          log('New visible count:', newVisibleCount);
          
          // Reset button
          btn.disabled = false;
          if (textSpan) textSpan.style.display = 'inline';
          if (loaderSpan) loaderSpan.style.display = 'none';
          
          updateButtonVisibility(groupId, btn, firstWrapper, totalProducts);
          
          groupState[groupId].loading = false;
          groupState[groupId].visibleCount = newVisibleCount;
          
          log('State after click:', groupState[groupId]);
          
          // Lazy load
          if (typeof BlsLazyloadImg !== 'undefined' && typeof BlsLazyloadImg.init === 'function') {
            BlsLazyloadImg.init();
          }
        }, 700);
        
        return false;
      }, true);

    // Initialize
    function init() {
      log('=== INIT CALLED ===');
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          log('DOM loaded, init groups');
          setTimeout(initAllGroups, 100);
        });
      } else {
        log('DOM already loaded, init groups');
        setTimeout(initAllGroups, 100);
      }
      
      setTimeout(initAllGroups, 300);
    }
    
    init();
    
      // Resize handler
      let resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          log('=== RESIZE, reinit ===');
          
          // CRITICAL: Only reset groups where user has NOT clicked
          Object.keys(groupState).forEach(function(groupId) {
            if (groupState[groupId] && !groupState[groupId].userHasClicked) {
              groupState[groupId].initialized = false;
              log('Reset group', groupId, 'for re-init');
            } else {
              log('Skip reset for group', groupId, '- user has clicked');
            }
          });
          
          initAllGroups();
        }, 250);
      });
  })();

  // Product Info Block - Tab Link Functionality - Vanilla JS
  document.addEventListener('click', function(e) {
  const link = e.target.closest('.product-info-block__extra-text--link[data-tab-class]');
  if (!link) return;
  
  e.preventDefault();
  e.stopPropagation();
  
  console.log('=== TAB LINK CLICKED ===');
  console.log('Event type:', e.type);
  console.log('Window width:', window.innerWidth);
  
  const tabClass = link.dataset.tabClass || link.getAttribute('data-tab-class');
  console.log('Tab class from link:', tabClass);
  
  if (!tabClass) {
    console.log('No tab class found!');
    return;
  }
  
  // Split multiple classes if provided (e.g., "betaling_tab" from "discription_tab betaling_tab")
  const classes = tabClass.trim().split(/\s+/);
  
  // Find the best matching tab
  let tabElement = null;
  let bestMatch = null;
  let bestMatchScore = 0;
  
  // CRITICAL: On mobile (<= 991px), only search tabs in .bls__product-details-infor
  // On desktop, search tabs in .bls__product-images
  const isMobileTabMode = window.innerWidth <= 991;
  const searchScope = isMobileTabMode ? '.bls__product-details-infor .tab-item' : '.tab-item';
  console.log('Searching in scope:', searchScope);
  
  // Search through all tabs to find the best match
  const allTabs = document.querySelectorAll(searchScope);
  allTabs.forEach(function(tab) {
    const tabClasses = tab.className.split(/\s+/).filter(function(c) {
      return c && c !== 'tab-item' && c !== 'tab-accordition' && c !== 'active' && c !== 'app-block';
    });
    
    // Calculate match score
    let matchScore = 0;
    let hasAllClasses = true;
    
    classes.forEach(function(targetClass) {
      if (tabClasses.indexOf(targetClass) !== -1) {
        matchScore += 2; // Exact match gets higher score
      } else {
        hasAllClasses = false;
      }
    });
    
    // Bonus points if tab has the target class and fewer other classes (more specific)
    if (matchScore > 0) {
      matchScore += (10 - tabClasses.length) * 0.1; // Prefer tabs with fewer classes (more specific)
    }
    
    // Perfect match: tab has all the classes we're looking for
    if (hasAllClasses && matchScore > bestMatchScore) {
      bestMatch = tab;
      bestMatchScore = matchScore;
    }
    // Good match: tab has at least one of the classes
    else if (matchScore > 0 && matchScore > bestMatchScore) {
      bestMatch = tab;
      bestMatchScore = matchScore;
    }
  });
  
  // Use the best match
  if (bestMatch) {
    tabElement = bestMatch;
  }
  
  // Fallback: if still not found, try simple selector in the correct scope
  if (!tabElement && classes.length > 0) {
    const fallbackTab = document.querySelector(searchScope + '.' + classes[0]);
    if (fallbackTab) tabElement = fallbackTab;
  }
  
  if (!tabElement) {
    console.warn('Tab not found for class:', tabClass);
    const allTabItems = document.querySelectorAll('.tab-item');
    console.log('All tabs:', allTabItems.length);
    allTabItems.forEach(function(tab, i) {
      console.log('Tab', i, 'classes:', tab.className);
    });
    return;
  }
  
  console.log('Found tab element:', tabElement);
  console.log('Tab element classes:', tabElement.className);
  
  const tabId = tabElement.id;
  console.log('Tab ID:', tabId);
  
  if (!tabId) {
    console.warn('Tab element has no ID');
    return;
  }
  
  const tabToggle = document.querySelector('[data-block-id="' + tabId + '"]');
  console.log('Tab toggle found:', tabToggle ? 1 : 0);
  
  if (!tabToggle) {
    console.warn('Tab toggle not found for ID:', tabId);
    return;
  }
  
  const isOpen = tabElement.classList.contains('active');
  const panel = tabElement.querySelector('.tab-panel');
  
  console.log('Panel found:', panel ? 1 : 0);
  if (panel) {
    console.log('Panel display:', window.getComputedStyle(panel).display);
  }
  console.log('Tab element visible:', window.getComputedStyle(tabElement).display !== 'none');
  const tabRect = tabElement.getBoundingClientRect();
  console.log('Tab element offset before opening:', { top: tabRect.top + window.scrollY, left: tabRect.left + window.scrollX });
  
  // Detect mobile for different scroll offset
  const isMobile = window.innerWidth < 1025;
  const scrollOffset = isMobile ? 150 : 100;
  const delay = isOpen ? 50 : 350;
  
  console.log('Is mobile:', isMobile);
  console.log('Scroll offset:', scrollOffset);
  console.log('Is tab open:', isOpen);
  console.log('Delay:', delay);
  
  // If it's an accordion tab
  if (tabElement.classList.contains('tab-accordition')) {
    // Close other tabs if needed (check for multi-open)
    const multiOpenContainer = tabElement.closest('[data-multi-open="true"]');
    const multiOpenGlobal = document.querySelector('.bls__product-tabs [data-multi-open="true"]');
    const hasMultiOpen = multiOpenContainer || multiOpenGlobal;
    
    if (!hasMultiOpen) {
      const container = tabElement.closest('.tab-content') || document;
      const activeTabs = container.querySelectorAll('.tab-item.active');
      activeTabs.forEach(function(activeTab) {
        if (activeTab === tabElement) return;
        activeTab.classList.remove('active');
        const p = activeTab.querySelector('.tab-panel');
        if (p) {
        if (typeof slideAnimeHidden === 'function') {
            slideAnimeHidden({ target: p });
        } else {
            p.style.display = 'none';
          }
        }
      });
    }
    
    // On mobile (<= 991px), use the theme's native tab toggle handler
    if (isMobileTabMode) {
      console.log('Mobile mode detected - TRIGGER CLICK on tab title');
      
      // Find the tab title element
      const title = tabElement.querySelector('.item.title');
      console.log('Title element found:', title ? 1 : 0);
      console.log('Tab is currently open:', isOpen);
      
      // If tab is closed, trigger a click to open it using the native handler
      if (!isOpen && title) {
        console.log('Triggering click on title to open tab...');
        title.click();
      }
      
      // Wait for animation, then scroll
      setTimeout(function() {
        // Force recalculate position after tab opens
        const tabRect = tabElement.getBoundingClientRect();
        const elementPosition = tabRect.top + window.scrollY;
        const offsetPosition = Math.max(0, elementPosition - scrollOffset);
        console.log('Mobile - Element position:', elementPosition);
        console.log('Mobile - Offset position:', offsetPosition);
        console.log('Mobile - Tab visible:', window.getComputedStyle(tabElement).display !== 'none');
        console.log('Mobile - Tab height:', tabElement.offsetHeight);
        if (panel) {
          console.log('Mobile - Panel display:', window.getComputedStyle(panel).display);
        }
        
        if (elementPosition > 0) {
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        } else {
          console.error('Mobile - Element position is still 0! Tab did not open properly.');
        }
      }, 500); // Wait for native animation to complete
      
    } else {
      // DESKTOP: Use original logic
      console.log('Desktop mode - using original logic');
      
      // Close other tabs if needed (check for multi-open)
      const multiOpenContainer2 = tabElement.closest('[data-multi-open="true"]');
      const multiOpenGlobal2 = document.querySelector('.bls__product-tabs [data-multi-open="true"]');
      const hasMultiOpen2 = multiOpenContainer2 || multiOpenGlobal2;
      
      if (!hasMultiOpen2) {
        const container = tabElement.closest('.tab-content') || document;
        const activeTabs = container.querySelectorAll('.tab-item.active');
        activeTabs.forEach(function(activeTab) {
          if (activeTab === tabElement) return;
          activeTab.classList.remove('active');
          const p = activeTab.querySelector('.tab-panel');
          if (p) {
          if (typeof slideAnimeHidden === 'function') {
              slideAnimeHidden({ target: p });
          } else {
              p.style.display = 'none';
            }
          }
        });
      }
      
      // Always open the target tab
      if (!isOpen && panel) {
        if (typeof slideAnime === 'function') {
          slideAnime({ target: panel, animeType: 'slideDown' });
        } else {
          panel.style.display = '';
        }
        tabElement.classList.add('active');
      }
      
      // Scroll to tab
      setTimeout(function() {
        const tabRect = tabElement.getBoundingClientRect();
        const elementPosition = tabRect.top + window.scrollY;
        const offsetPosition = Math.max(0, elementPosition - scrollOffset);
        console.log('Desktop - Element position:', elementPosition);
        console.log('Desktop - Offset position:', offsetPosition);
        
        if (elementPosition > 0) {
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, isOpen ? 50 : 350);
    }
    
  } else {
    // Handle regular tabs (nav tabs)
    if (!isOpen && panel) {
      // Close other tabs
      document.querySelectorAll('.data.item').forEach(function(item) {
        item.classList.remove('active');
      });
      document.querySelectorAll('.tab-item').forEach(function(item) {
        item.classList.remove('active');
        const p = item.querySelector('.tab-panel');
        if (p) p.style.display = 'none';
      });
      
      // Open target tab
      tabElement.classList.add('active');
      panel.style.display = '';
      const dataItem = tabToggle.closest('.data.item');
      if (dataItem) dataItem.classList.add('active');
    }
    
    // Scroll to tab
    setTimeout(function() {
      const tabRect = tabElement.getBoundingClientRect();
      const elementPosition = tabRect.top + window.scrollY;
      const offsetPosition = Math.max(0, elementPosition - scrollOffset);
      console.log('Nav tab - Element position:', elementPosition);
      console.log('Nav tab - Offset position:', offsetPosition);
      console.log('Nav tab - Current scroll:', window.scrollY || window.pageYOffset);
      
      // Use native smooth scroll for better mobile support
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }, delay);
  }
  
  console.log('=== TAB LINK END ===');
  }); // Close document.addEventListener('click') for tab link functionality
  
  // ============================================
  // Mobile Tab Accordion - Vanilla JS (moved from theme.liquid)
  // ============================================
  // Helper functions for slide animations
  function slideUp(element, duration = 300) {
    if (!element) return;
    const height = element.scrollHeight;
    element.style.height = height + 'px';
    element.style.overflow = 'hidden';
    element.style.transition = `height ${duration}ms ease`;
    
    setTimeout(() => {
      element.style.height = '0px';
    }, 10);
    
    setTimeout(() => {
      element.style.display = 'none';
      element.style.height = '';
      element.style.overflow = '';
      element.style.transition = '';
    }, duration);
  }
  
  function slideDown(element, duration = 300) {
    if (!element) return;
    element.style.display = 'block';
    const height = element.scrollHeight;
    element.style.height = '0px';
    element.style.overflow = 'hidden';
    element.style.transition = `height ${duration}ms ease`;
    
    setTimeout(() => {
      element.style.height = height + 'px';
    }, 10);
    
    setTimeout(() => {
      element.style.height = '';
      element.style.overflow = '';
      element.style.transition = '';
    }, duration);
  }
  
  // ============================================
  // Swiper initialization moved to per-section Liquid javascript tags
  // This follows Shopify best practice for modular, maintainable code
  // ============================================
  
  // ============================================
  // Cart Upsell Section Update - Update upsell when cart changes
  // ============================================
  function updateCartUpsellSection() {
    const mainCartItems = document.getElementById('main-cart-items');
    if (!mainCartItems) return;
    
    const sectionId = mainCartItems.dataset.id;
    if (!sectionId) return;
    
    // Build sections URL to fetch the updated cart section
    const sectionsUrl = `/?sections=${sectionId}`;
    
    fetch(sectionsUrl)
      .then(res => res.json())
      .then(sections => {
        if (sections[sectionId]) {
          const html = new DOMParser().parseFromString(sections[sectionId], 'text/html');
          
          // Find the upsell section in the new HTML - it's inside the cart form
          const newUpsellContainer = html.querySelector('.hob-cart-upsell');
          
          // Find current upsell section
          const currentUpsellContainer = document.querySelector('.hob-cart-upsell');
          
          if (newUpsellContainer && currentUpsellContainer) {
            // Replace the upsell section
            currentUpsellContainer.outerHTML = newUpsellContainer.outerHTML;
          } else if (newUpsellContainer && !currentUpsellContainer) {
            // Upsell section doesn't exist, add it after cart-items
            const cartItems = document.querySelector('cart-items');
            if (cartItems && cartItems.parentElement) {
              cartItems.parentElement.insertAdjacentHTML('afterend', newUpsellContainer.outerHTML);
            }
          } else if (!newUpsellContainer && currentUpsellContainer) {
            // Upsell section should be removed
            currentUpsellContainer.remove();
          }
        }
      })
      .catch(error => {
        console.error('Error updating upsell section:', error);
      });
  }
  
  // Observe the .js-contents element for changes (this is what cart.js updates)
  function initCartUpsellObserver() {
    const jsContents = document.querySelector('.js-contents');
    if (!jsContents) return;
    
    const observer = new MutationObserver(function(mutations) {
      let shouldUpdate = false;
      
      mutations.forEach(function(mutation) {
        // Check if nodes were added or removed
        if (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0) {
          shouldUpdate = true;
        }
        // Check if the innerHTML changed (which happens when cart.js updates the content)
        if (mutation.type === 'childList') {
          shouldUpdate = true;
        }
      });
      
      if (shouldUpdate) {
        // Debounce the update
        clearTimeout(window.cartUpsellUpdateTimeout);
        window.cartUpsellUpdateTimeout = setTimeout(updateCartUpsellSection, 300);
      }
    });
    
    // Start observing
    observer.observe(jsContents, {
      childList: true,
      subtree: true
    });
    
    // Also observe the cart-items element itself
    const cartItems = document.querySelector('cart-items');
    if (cartItems) {
      observer.observe(cartItems, {
        childList: true,
        subtree: true
      });
    }
  }
  
  // Initialize observer (init() is already called when DOM is ready)
  setTimeout(initCartUpsellObserver, 500);

  // ============================================
  // Desktop Mega Header Predictive Search (scoped)
  // ============================================
  function initDesktopMegaPredictiveSearch() {
    const desktopInput = document.querySelector('.top-search input[type="search"]');
    if (!desktopInput) return;

    const headerSearch = desktopInput.closest('.header_search');
    if (!headerSearch) return;
    if (headerSearch.dataset.megaSearchInit === 'true') return;
    headerSearch.dataset.megaSearchInit = 'true';

    const predictiveWrapper = headerSearch.querySelector('[data-predictive-search-results], #predictive-search');
    const predictiveContainer = headerSearch.querySelector('[data-predictive-search]');
    if (!predictiveWrapper || !predictiveContainer) return;

    const searchUrlBase = (window.routes && window.routes.search_url) ? window.routes.search_url : '/search';
    const sectionId = headerSearch.querySelector('.search_type_popup') ? 'search-predictive-grid' : 'search-predictive-list';
    let debounceTimer;

    const setLoading = (isLoading) => {
      const form = headerSearch.querySelector('[data-search-form], #search_mini_form');
      if (form) form.classList.toggle('loading', isLoading);
      predictiveWrapper.classList.toggle('loading', isLoading);
    };

    const renderResults = (markup) => {
      predictiveContainer.innerHTML = markup;
      predictiveWrapper.classList.add('results');
      const quickSearch = headerSearch.querySelector('#quick-search');
      if (quickSearch) quickSearch.classList.add('d-none');
      if (window.BlsColorSwatchesShopify && typeof window.BlsColorSwatchesShopify.init === 'function') {
        window.BlsColorSwatchesShopify.init();
      }
      if (window.BlsLazyloadImg && typeof window.BlsLazyloadImg.init === 'function') {
        window.BlsLazyloadImg.init();
      }
      setLoading(false);
    };

    const clearResults = () => {
      predictiveWrapper.classList.remove('results');
      const quickSearch = headerSearch.querySelector('#quick-search');
      if (quickSearch) quickSearch.classList.remove('d-none');
      setLoading(false);
    };

    const fetchResults = (searchTerm) => {
      const url = `${searchUrlBase}?q=${encodeURIComponent(searchTerm)}&resources[type]=product,page,article,query,collection&section_id=${sectionId}`;
      setLoading(true);
      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const section = doc.querySelector(`#shopify-section-${sectionId}`);
          renderResults(section ? section.innerHTML : '');
        })
        .catch(() => {
          clearResults();
        });
    };

    const handleInput = () => {
      const searchTerm = desktopInput.value.trim();
      if (!searchTerm.length) {
        clearResults();
        return;
      }
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => fetchResults(searchTerm), 300);
    };

    desktopInput.addEventListener('input', handleInput);
    desktopInput.addEventListener('focus', handleInput);

    const updateOpenState = () => {
      const popup = headerSearch.querySelector('.popup-search');
      const isOpen = popup && popup.classList.contains('popup-search-show');
      headerSearch.classList.toggle('mega-search-open', !!isOpen);
    };

    document.addEventListener('click', () => {
      setTimeout(updateOpenState, 0);
    });
    desktopInput.addEventListener('focus', () => {
      setTimeout(updateOpenState, 0);
    });
    updateOpenState();
  }

  // Call initDesktopMegaPredictiveSearch (init() is already called when DOM is ready)
  initDesktopMegaPredictiveSearch();

} // End init function
  
  // If DOM is already loaded, execute immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOM already loaded
    init();
  }
})(); // End IIFE
